// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__h5SOZ","detailsBorder":"styles_detailsBorder__2Xnte"};